<template>
  <component
    v-if="component"
    :is="component"
    :payment-type="paymentType"
    :order-id="orderId"
    :mode="mode"
    :options="options"
    :smartCart="smartCart"
  />
</template>
<script>
import gateway from "~/mixins/gateway";
export default {
  name: "GatewayWriter",
  mixins: [gateway],
  props: {
    componentName: { type: String, required: true },
    smartCart: { type: Object, required: false }
  },
  data() {
    return {
      component: null
    };
  },
  computed: {
    loader() {
      return () => import("./" + this.componentName);
    }
  },
  mounted() {
    this.loader()
      .then(() => {
        this.component = () => this.loader();
      })
      .catch(() => {});
  }
};
</script>
